import React from 'react'

import { isNil } from 'ramda'

import { Flex, Link, Text } from '@driftt/dds'
import { CubeQueryStringAdapter } from '@driftt/dds.reports'

import { ReportKPICard, Score } from 'components/KPICard'
import { TypeFormats } from 'utils/format'

import useClosedWonKPI from './ClosedWon.hooks'

const RESPONSE_RATE_RANGE_DESCRIPTION = `Needs work = less than 70%
Fair = 70% - 79%
Good = 80% - 89%
Excellent = 90% - 100%`

const ROI_OPPORTUNITY_REPORT_PATH = '/reports/revenue/opportunities'

export const ClosedWon = ({ isInfluenced, isSourced }) => {
  const {
    influencedOpportunityClosedWonCount,
    opportunityClosedWonAmountSum,
    percentageOfOpportunitiesInfluenced,
    hasNoData,
    hasError,
    isLoading,
    opportunityClosedWonInfluencedCountCubeQuery,
  } = useClosedWonKPI({
    isInfluenced,
    isSourced,
  })

  const drillDownQueryString = CubeQueryStringAdapter.toQueryString(
    opportunityClosedWonInfluencedCountCubeQuery
  )
  return (
    <ReportKPICard
      title="Closed won"
      isLoading={isLoading}
      isError={hasError}
      hasNoData={hasNoData}
      subtitle="Drift influenced opportunities from this time period that were closed won"
      score={Score.None}
      metric={opportunityClosedWonAmountSum}
      metricRange={RESPONSE_RATE_RANGE_DESCRIPTION}
      formatMetric={(responseRate: number) =>
        TypeFormats.CURRENCY(responseRate)
      }
      childrenFlexGap={2}
    >
      {!isNil(influencedOpportunityClosedWonCount) && (
        <Text variant="body">
          <b>{influencedOpportunityClosedWonCount}</b> opportunities closed won
        </Text>
      )}
      {!!percentageOfOpportunitiesInfluenced && (
        <Flex gap="half" direction="column" grow={0}>
          <Text variant="bodyBold" color="$gray10">
            {TypeFormats.PERCENT_WITH_DECIMAL(
              percentageOfOpportunitiesInfluenced
            )}{' '}
            of total closed won
          </Text>
          <Text variant="metadata">opportunities were influenced by Drift</Text>
        </Flex>
      )}
      <Link
        target="_blank"
        variant="inline"
        href={`${ROI_OPPORTUNITY_REPORT_PATH}?${drillDownQueryString}`}
      >
        View data
      </Link>
    </ReportKPICard>
  )
}
